module.exports = __webpack_public_path__ + "static/media/file-xls.7de622a3.svg";